import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {
	return {
		processingVideoContainer: {
			borderRadius  : "1.5rem",
			display       : "flex",
			gap           : "1rem",
			flexDirection : "column"
		},
		contentContainer: {

		},
		thumbnail: {
			aspectRatio  : props?.cardType === "reel" ? "9/16" : "16 / 9",
			borderRadius : "1.5rem"

		},
		videoContainer: {
			aspectRatio  : props?.cardType === "reel" ? "9/16" : "16 / 9",
			borderRadius : "1.5rem"
		}
	};
} );

